export default "__VITE_ASSET__D7q3ov$f__"